import type { ViewDefinitionConfig } from '@/components/lemmala-design-system/table/hooks/use-ag-filter-manager'
import type { ViewItem } from '@/components/lemmala-design-system/table/types'
import { TabBadge } from '@/components/lemmala-design-system/tabs/tab-badge'
import { Tabs, TabsList, TabsTrigger } from '@/components/lemmala-design-system/tabs/tabs'

export interface AgViewsSwitcherProps {
  views: Array<ViewItem>
  selectedView: string
  onViewChange?: (viewName: string) => void
  applyView?: (
    viewName: string,
    preserveExistingFilters?: boolean,
    clearUrlFilters?: boolean,
  ) => void
  className?: string
  getViewDefinition?: ViewDefinitionConfig['getViewDefinition']
}

export const AgViewsSwitcher = ({
  views,
  selectedView,
  onViewChange,
  applyView,
  className,
  getViewDefinition,
}: AgViewsSwitcherProps) => {
  const normalized = views.map((v) =>
    typeof v === 'string' ? { name: v, label: v } : { ...v, label: v.label ?? v.name },
  )

  const tabs = normalized.map(({ name, label, icon, counter }) => {
    if (getViewDefinition) getViewDefinition(name)
    return { label, icon, counter, value: name }
  })

  const handleChange = (value: string) => {
    if (onViewChange) onViewChange(value)
    else if (applyView) applyView(value)
  }

  return (
    <Tabs value={selectedView} onValueChange={handleChange} className={className}>
      {/* The strip carries the baseline rule full width; the active tab overlaps it. */}
      <TabsList className='w-full justify-start gap-2 border-b border-main-border-default'>
        {tabs.map(({ value, label, icon, counter }) => (
          <TabsTrigger
            key={value}
            value={value}
            // -mb-px sits the 2px active underline on the baseline instead of stacking above it.
            // `group` is what lets TabBadge react to the active state.
            className='group -mb-px border-b-2 border-transparent px-2 data-[state=active]:border-main-border-accent data-[state=active]:text-main-foreground-accent'
          >
            {icon}
            <span>{label}</span>
            <TabBadge badge={counter} />
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
